import { useState, useEffect } from 'react';
import { SupportFormUrls } from '../components/contact';
import { translatableText } from '../utils/translatable-text';
import { getLoginUrl } from '../utils/get-auth-url';
import { getRelativeLocalizedContactPath } from '../utils/get-relative-localized-contact-path';
import { isSacCstAuthEnabled } from '../../feature-flags';

interface ContactLink {
    authenticated: HrefElement;
    needsAuthentication: HrefElement;
}

interface HrefElement {
    href: string;
    text: string;
}

export const useSupportFormUrls = (customSupportFormURLs?: SupportFormUrls) => {
    const [isCstFlagEnabled, setIsCstFlagEnabled] = useState(false);
    const [supportFormLinks, setSupportFormLinks] = useState<ContactLink>({
        needsAuthentication: {
            text: '',
            href: ''
        },
        authenticated: {
            text: translatableText.contactSupport.text,
            href: '/contact'
        }
    });

    useEffect(() => {
        const updateSupportFormUrls = async function () {
            setIsCstFlagEnabled(await isSacCstAuthEnabled());
            const relativeContactURL = getRelativeLocalizedContactPath();

            const contactUrl = isCstFlagEnabled
                ? `${relativeContactURL}`
                : `${window.location.origin}${relativeContactURL}`;

            setSupportFormLinks({
                needsAuthentication: {
                    text: translatableText.logInToContactSupport.text,
                    href: await getLoginUrl(
                        customSupportFormURLs &&
                            customSupportFormURLs.authenticated
                            ? customSupportFormURLs.authenticated
                            : `${window.location.origin}${relativeContactURL}`,
                        String(isCstFlagEnabled)
                    )
                },
                authenticated: {
                    text: translatableText.contactSupport.text,
                    href:
                        customSupportFormURLs &&
                        customSupportFormURLs.authenticated
                            ? customSupportFormURLs.authenticated
                            : contactUrl
                }
            });
        };

        updateSupportFormUrls();
    }, [customSupportFormURLs, isCstFlagEnabled]);

    return supportFormLinks;
};
